import Vue from 'vue'
import { getCookie } from '@/utils/auth'
import Router from 'vue-router'
import Layout from '../views/layout/index'
import CompanyLayout from '../views/backstagemanage/layout/Layout'
import AdminLayout from '../views/adminmanage/layout/Layout'
import phoneLayout from '../views/phoneLayout/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/center',
      name: 'Layout',
      redirect: '/center/personinfo',
      component: Layout,
      hidden: true,
      children: [
        {
          path: 'personinfo',
          name: 'personinfo',
          meta: { title: '个人信息' },
          component: () => import('@/views/personinfo/index')
        },
        {
          path: 'editpwd',
          name: 'editpwd',
          meta: { title: '修改密码' },
          component: () => import('@/views/editpwd/index')
        }
        // {
        //   path: 'accountbind',
        //   name: 'accountbind',
        //   meta: { title: '账号绑定' },
        //   component: () => import('@/views/accountbind/index')
        // }
      ]
    },
    {
      path: '/backstagemanage',
      name: 'companyLayout',
      redirect: '/backstagemanage/customer',
      component: CompanyLayout,
      meta: { title: '后台管理', icon: 'user' },
      children: [
        {
          path: 'customer',
          name: 'customer',
          component: () => import('@/views/backstagemanage/customer/index'),
          meta: { title: '客户管理', icon: 'user' }
        },
        {
          path: 'commodity',
          name: 'commodity',
          component: () => import('@/views/backstagemanage/commodity/index'),
          meta: { title: '油品管理', icon: 'user' }
        }
      ]
    },
    {
      path: '/adminmanage',
      name: 'adminLayout',
      redirect: '/adminmanage/region',
      component: AdminLayout,
      meta: { title: '后台管理', icon: 'user' },
      children: [
        {
          path: 'region',
          name: 'region',
          component: () => import('@/views/adminmanage/region/index'),
          meta: { title: '片区管理', icon: 'user' }
        },
        {
          path: 'oilstation',
          name: 'oilstation',
          component: () => import('@/views/adminmanage/oilstation/index'),
          meta: { title: '油站管理', icon: 'user' }
        },
        {
          path: 'user',
          name: 'user',
          component: () => import('@/views/adminmanage/user/index'),
          meta: { title: '用户管理', icon: 'user' }
        }
      ]
    },
    {
      path: '/',
      redirect: getCookie('redirectUrl') ? `/${getCookie('redirectUrl')}` : 'dashboard',
      hidden: true
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/home/index'),
      hidden: true
    },
    {
      path: '/home2',
      name: 'home2',
      component: () => import('@/views/home/index2'),
      hidden: true
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index'),
      hidden: true
    },
    {
      path: '/check',
      name: 'check',
      component: () => import('@/views/login/check'),
      hidden: true
    },
    {
      path: '/bind',
      name: 'bind',
      component: () => import('@/views/accountbind/bind'),
      hidden: true
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/dashboard/index'),
      hidden: true
    },
    {
      path: '/leakage',
      name: 'leakage',
      component: () => import('@/views/leakage/index')
    },
    {
      path: '/wap',
      name: 'phoneLayout',
      redirect: '/wap/phoneManageanalysis',
      component: phoneLayout,
      children: [
        {
          path: '/wap/phoneManageanalysis',
          name: 'phoneManageanalysis',
          component: () => import('@/views/phoneManageanalysis/index')
        },
        {
          path: '/wap/dashboard',
          name: 'phoneDashboard',
          component: () => import('@/views/dashboard/index')
        }
      ]
    },
    {
      path: '/backstagemanage/companylogin',
      name: 'companylogin',
      component: () => import('@/views/backstagemanage/login/index'),
      hidden: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js